import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);

const ESignature = lazy(() => import('src/pages/signature/ESignature'));
const DocumentList = lazy(() => import('src/pages/document/document-list'));

// ----------------------------------------------------------------------

export const TestRoutes = [
  {
    path: 'test',
    element: (
      <DashboardLayoutStore>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayoutStore>
    ),
    children: [
      { element: <ESignature />, index: true },
      // { path: 'edition', element: <DocumentEditorStore /> },
    ],
  },
];
